export default __webpack_public_path__ + "static/media/icon-2.d1dc96e4.svg";